// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".floating-top[data-v-500c131e]{position:fixed;right:40px;cursor:pointer;opacity:0;visibility:hidden;z-index:9997;transition:opacity .3s ease,visibility .3s ease,bottom .3s ease}.floating-top.on[data-v-500c131e]{opacity:1;visibility:visible}.floating-top img[data-v-500c131e]{width:50px;height:50px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
